/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Damage_Amount_NonnegativeInputs */

const en_case_validation_damage_amount_nonnegative = /** @type {(inputs: Case_Validation_Damage_Amount_NonnegativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value must be a positive number.`)
};

const pt_br2_case_validation_damage_amount_nonnegative = /** @type {(inputs: Case_Validation_Damage_Amount_NonnegativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor deve ser um número positivo.`)
};

/**
* | output |
* | --- |
* | "Value must be a positive number." |
*
* @param {Case_Validation_Damage_Amount_NonnegativeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_damage_amount_nonnegative = /** @type {((inputs?: Case_Validation_Damage_Amount_NonnegativeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Damage_Amount_NonnegativeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_damage_amount_nonnegative(inputs)
	return pt_br2_case_validation_damage_amount_nonnegative(inputs)
});